import * as Yup from 'yup';

import { FileObj, Nullable } from '~globals/types';
import { VALIDATIONS_ERROR } from '~constants/index';

export const FIELDS_NAME = {
  FILES: 'files',
  OWNER_COMPANY_ID: 'ownerCompanyId',
} as const;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInitialValues = (defaultOwnerCompanyId: Nullable<string>) => ({
  [FIELDS_NAME.FILES]: [] as FileObj[],
  [FIELDS_NAME.OWNER_COMPANY_ID]: defaultOwnerCompanyId ?? '',
});

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.FILES]: Yup.array()
    .of(Yup.mixed())
    .min(1, VALIDATIONS_ERROR.REQUIRED),
  [FIELDS_NAME.OWNER_COMPANY_ID]: Yup.string().required(
    VALIDATIONS_ERROR.REQUIRED,
  ),
});
